import PanelLayout from './PanelLayout.vue';
import BlankLayout from './BlankLayout.vue';

export const layouts = {
    PanelLayout,
    BlankLayout,
};
